import React from "react";
import {
    DataTable
} from 'carbon-components-react';
import LockedEntries from '../components/TaskDetails/LockedEntries'
const {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableExpandHeader,
    TableExpandRow,
    TableExpandedRow,
    TableHead,
    TableHeader,
    TableRow
} = DataTable

function OnExpandTrigger() {
    alert("OnExpandTrigger");
  }
  
  function OnClickTrigger() {
    alert("OnClickTrigger");
  }


  // function getRows(){
    
  // }
    const TableComponent = (props) => {
    return (
        <DataTable size="tall" className = {props.className} rows={props.rows} headers={props.headers}
        render={({ rows, headers, getHeaderProps, getRowProps, getTableProps }) => (
            <TableContainer title="">
              <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    <TableExpandHeader />
                    {headers.map((header) => (
                      <TableHeader {...getHeaderProps({ header })}>
                        {header.header}
                      </TableHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <React.Fragment key={row.id}>
                      <TableExpandRow
                       
                        {...getRowProps({ row })}
                      >
                        {row.cells.map((cell) => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableExpandRow>
                      {row.isExpanded && (
                        <TableExpandedRow colSpan={headers.length + 1}>
                         { props.lockedEntries && props.rows[index]["lockedEntries"] && props.rows[index]["lockedEntries"].length ? <LockedEntries data={props.rows[index]["lockedEntries"]} />: '' }
                        </TableExpandedRow>
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        />
    );
}
export const Usage = (props) => (
  <DataTable rows={props.rows} headers={props.headers}>
    {({
      rows,
      headers,
      getHeaderProps,
      getRowProps,
      getTableProps,
      getTableContainerProps,
    }) => (
      <TableContainer
        title=""
        description=""
        {...getTableContainerProps()}>
        <Table {...getTableProps()} isSortable>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableHeader
                  key={header.key}
                  {...getHeaderProps({ header })}
                  isSortable>
                  {header.header}
                </TableHeader>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} {...getRowProps({ row })}>
                {row.cells.map((cell) => (
                  <TableCell key={cell.id}>{cell.value}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </DataTable>
);

export default TableComponent;
